import { Box, Grid, Skeleton, Typography } from '@mui/material'
import React from 'react'
import globalConfig from '../../../../../config/globalConfig'
import useFetchData from '../../../../../hooks/useFetchData'
import CredentialsApps from './ApiKeys/ApiKeys'
import TextCopyClipboard from '../../../../text/TextCopyClipboard'
import { useSelector } from 'react-redux'

const ApiServices = () => {
  const { isLoading, data: versionBE } = useFetchData('/version')
  const tenantId = useSelector((state) => state?.tenant?.tenant?.tenantId || null)

  return (
    <>
      <Box className='bg-primary text-primary-foreground px-4 py-1 flex gap-4 items-center justify-between h-8'>
        <Typography variant='subtitle1' className='uppercase'>
          Maestro app information
        </Typography>
      </Box>
      <Box className='px-4 pt-6 pb-4'>
        <Grid item lg={10} sm={9} container spacing={2} alignItems={'center'}>
          <Grid item md={2} sm={3}>
            <Typography variant='inherit' color='primary' className='font-bold' align='right' component='p'>
              Tenant ID
            </Typography>
          </Grid>
          <Grid item md={10} sm={9}>
            <TextCopyClipboard text={tenantId} />
          </Grid>
          <Grid item md={2} sm={3}>
            <Typography variant='inherit' color='primary' className='font-bold' align='right' component='p'>
              URL Backend
            </Typography>
          </Grid>
          <Grid item md={10} sm={9}>
            <TextCopyClipboard text={globalConfig.axios.apiUrl} />
          </Grid>
          <Grid item md={2} sm={3}>
            <Typography variant='inherit' color='primary' className='font-bold' align='right' component='p'>
              Version Backend
            </Typography>
          </Grid>
          <Grid item md={10} sm={9}>
            <Typography>{isLoading ? <Skeleton /> : `v${versionBE}`}</Typography>
          </Grid>
          <Grid item md={2} sm={3}>
            <Typography variant='inherit' color='primary' className='font-bold' align='right' component='p'>
              URL Frontend
            </Typography>
          </Grid>
          <Grid item md={10} sm={9}>
            <TextCopyClipboard text={window.location.origin} />
          </Grid>
          <Grid item md={2} sm={3}>
            <Typography variant='inherit' color='primary' className='font-bold' align='right' component='p'>
              Version Frontend
            </Typography>
          </Grid>
          <Grid item md={10} sm={9}>
            <Typography>v{__APP_VERSION__}</Typography>
          </Grid>
        </Grid>
      </Box>
      <CredentialsApps />
    </>
  )
}

export default ApiServices
